module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.5553b9f0.svg";